import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/advertiser/_blank")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
